module.exports = __webpack_public_path__ + "media/images/wechat_logo-5991ab2bd440ecc8643df2413bcd6a72.svg";